import { render, staticRenderFns } from "./FM_purseInfo.vue?vue&type=template&id=7d5c04b2&"
import script from "./FM_purseInfo.vue?vue&type=script&lang=js&"
export * from "./FM_purseInfo.vue?vue&type=script&lang=js&"
import style0 from "./FM_purseInfo.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports